import { render, staticRenderFns } from "./top-data.vue?vue&type=template&id=7148acb5&scoped=true&"
import script from "./top-data.vue?vue&type=script&lang=js&"
export * from "./top-data.vue?vue&type=script&lang=js&"
import style0 from "./top-data.vue?vue&type=style&index=0&id=7148acb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7148acb5",
  null
  
)

export default component.exports